export default __webpack_public_path__ + "static/media/cert-cpttm.465f64c5.jpg";